//Funciones comunes
import { LogErrors } from './../LogErrors'
//import { useLanguage } from './../LanguageContext' // Importa el hook
import { ValidateSqlInjection } from './Security'

//Funciones personalizadas
import { CheckAccessCode as BLCheckAccessCode } from './../BL/Sessions'


//Agregar multiidioma en los mensajes


/**
 * Función que valida los datos ingresados, obtiene la url de la página para el login y la devuelve
 * @param {Object} formData Información del formulario { accessCode }
 * @returns {Object} Resultado del proceso { success: boolean, errors: Object, data: Object }
 */
const CheckAccessCode = async (formData) => {
    //const { translate } = useLanguage() // Obtén la función de traducción desde el contexto
    try {
        // Validación de los datos del formulario
        const errors = {}
        const regex = /^[a-z0-9]{4}-[a-z0-9]{4}$/

        if (formData.accessCode) {
            // Quitar espacios al inicio y final
            formData.accessCode = formData.accessCode.trim()
            
            if (!regex.test(formData.accessCode.toLowerCase())) {
                errors.accessCode = 'El código de acceso es incorrecto. Debes cumplir con el formato: XXXX-XXXX'
            } else if (ValidateSqlInjection(formData.accessCode)) {
                errors.accessCode = 'El código de acceso que escribiste es inválido'
            }
        } else {
            errors.accessCode = 'El código de acceso es obligatorio'
        }
        
        // Si hay errores, retornar inmediatamente
        if (Object.keys(errors).length > 0) {
            return { success: false, errors }
        }
        
        // Llamar a la capa de datos para autenticar al usuario
        const response = await BLCheckAccessCode(formData.accessCode)
        
        if (response.success) {
            return { success: true, data: response.data } // Retornar la respuesta exitosa
        } else {
            // Manejar errores del backend (por ejemplo, credenciales incorrectas)
            return { success: false, errors: { general: response.message } }
        }
    } catch (error) {
        await LogErrors('CheckAccessCode Logins BL', error)
        return { success: false, errors: { general: error || 'Ocurrió un error inesperado' } }
    }
}

export { CheckAccessCode };